import { render, staticRenderFns } from "./DashboardItemForm.vue?vue&type=template&id=9b2293fc&scoped=true"
import script from "./DashboardItemForm.vue?vue&type=script&lang=js"
export * from "./DashboardItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2293fc",
  null
  
)

export default component.exports